import $ from 'jquery';
import '../vendors/jquery.event.move';
import '../vendors/jquery.twentytwenty';

$(window).on('load', function(){
	$( ".c-compare-slider" ).twentytwenty();
} );

